import React from 'react';
import './App.css'
const Home = () => {
    return (
        <div >
            <h1>Home</h1>
            <p>Welcome to my website! I made this to review <b>React</b> and <b>TypesScript</b> and to talk a bit about myself. </p>
            <h3>Click on the links above (or to the right on mobile) to navigate the various pages. </h3>
        </div>
    );
};



export default Home;